var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{attrs:{"left":_vm.left}},[_vm._v(_vm._s(_vm.iconValue))])
}
var staticRenderFns = []

export { render, staticRenderFns }